import _asyncToGenerator from "/home/runner/work/me/me/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/home/runner/work/me/me/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/runner/work/me/me/node_modules/@babel/runtime/regenerator";
import { useEffect as w, useRef as L } from "react";

var g = function g(e, t) {
  var n = L();
  w(function () {
    return Promise.resolve(e()).then(function (r) {
      typeof r == "function" && (n.current = r);
    }), function () {
      var _n$current;

      (_n$current = n.current) === null || _n$current === void 0 ? void 0 : _n$current.call(n);
    };
  }, t);
};

import { useEffect as S, useState as A } from "react";
import { useRef as F } from "react";

var O = function O(e, t, n) {
  var r = F(!1),
      _A = A(n),
      _A2 = _slicedToArray(_A, 2),
      o = _A2[0],
      s = _A2[1];

  return S(function () {
    return r.current = !1, e().then(function (u) {
      r.current || s(u);
    }), function () {
      r.current = !0;
    };
  }, t), o;
};

import { useState as K } from "react";

var U = function U() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;

  var _K = K(e),
      _K2 = _slicedToArray(_K, 2),
      t = _K2[0],
      n = _K2[1];

  return [t, {
    on: function on() {
      return n(!0);
    },
    off: function off() {
      return n(!1);
    },
    toggle: function toggle() {
      return n(!t);
    }
  }];
};

var d = {
  clearAuto: !0
};
import { useEffect as _ } from "react";
import { useRef as V } from "react";

var v = function v() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var t = V(e);
  return {
    _ref: t,
    clear: function clear() {
      t.current.length = 0;
    },
    add: function add() {
      var _t$current;

      (_t$current = t.current).push.apply(_t$current, arguments);
    }
  };
};

var f = function f() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : d,
      e = _ref.clearAuto;

  var _v = v(),
      t = _v._ref,
      n = _v.add,
      r = _v.clear,
      o = function o(u, i) {
    return n(setTimeout(u, i));
  },
      s = function s() {
    t.current.forEach(function (u) {
      clearTimeout(u);
    }), r();
  };

  return _(function () {
    return function () {
      e && s();
    };
  }, [e]), {
    use: o,
    disuse: s,
    _ref: t
  };
};

var P = function P() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : d;

  var _f = f(e),
      t = _f.use,
      n = _f.disuse,
      r = _f._ref;

  return {
    use: function use(s, u) {
      n(), t(s, u);
    },
    disuse: n,
    _ref: r
  };
};

import { useEffect as D, useRef as k } from "react";
var E = {
  clearAuto: !0
};

var c = function c() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : E,
      e = _ref2.clearAuto;

  var t = k([]),
      n = function n(o, s, u, i) {
    var a = typeof o == "function" ? o() : o;
    a.addEventListener(s, u, i), t.current.push([a, s, u, i]);
  };

  D(function () {
    return function () {
      e && r();
    };
  }, [e]);

  var r = function r() {
    t.current.forEach(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 4),
          o = _ref4[0],
          s = _ref4[1],
          u = _ref4[2],
          i = _ref4[3];

      o.removeEventListener(s, u, i);
    }), t.current = [];
  };

  return {
    add: n,
    remove: r,
    _ref: t
  };
};

import { useCallback as T, useEffect as W, useMemo as C, useState as H } from "react";
var b = typeof window != "undefined";

var h = function h(e) {
  return e === "" ? " " : e.startsWith("#") ? e : "#".concat(e);
},
    I = function I(e) {
  if (!b) return "";
  var t = typeof e == "undefined" ? void 0 : typeof e == "string" ? e : e();
  return typeof t == "string" && window.history.replaceState(null, document.title, h(t)), window.location.hash;
},
    N = function N(e, t) {
  var _t$hashMark;

  var n = (_t$hashMark = t === null || t === void 0 ? void 0 : t.hashMark) !== null && _t$hashMark !== void 0 ? _t$hashMark : !0,
      _H = H(I(e)),
      _H2 = _slicedToArray(_H, 2),
      r = _H2[0],
      o = _H2[1],
      s = T(function () {
    return o(window.location.hash);
  }, []),
      u = T(function (p) {
    var m = h(p);
    m !== r && (window.history.replaceState(null, document.title, m), window.dispatchEvent(new HashChangeEvent("hashchange")));
  }, [r]),
      _c = c(),
      i = _c.add;

  return W(function () {
    i(window, "hashchange", s);
  }, []), [C(function () {
    return n ? r : r.replace("#", "");
  }, [r, n]), u];
};

import { useEffect as j, useRef as q } from "react";

var y = function y() {
  var e = q(!1);
  return j(function () {
    return function () {
      e.current = !0;
    };
  }, []), e;
};

import { useReducer as B } from "react";

var $ = function $(e, _ref5) {
  var t = _ref5.type,
      n = _ref5.payload;

  switch (t) {
    case "increment":
      return e + (n !== null && n !== void 0 ? n : 1);

    case "decrement":
      return e - (n !== null && n !== void 0 ? n : 1);

    case "set":
      return n !== null && n !== void 0 ? n : 0;
  }
},
    z = function z() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var _B = B($, e),
      _B2 = _slicedToArray(_B, 2),
      t = _B2[0],
      n = _B2[1];

  return [t, {
    inc: function inc(r) {
      return n({
        type: "increment",
        payload: r
      });
    },
    dec: function dec(r) {
      return n({
        type: "decrement",
        payload: r
      });
    },
    set: function set(r) {
      return n({
        type: "set",
        payload: r
      });
    }
  }];
};

import { useState as X } from "react";

var Y = function Y() {
  var _X = X(!1),
      _X2 = _slicedToArray(_X, 2),
      e = _X2[0],
      t = _X2[1],
      n = y();

  return [e, /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(o) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (e || n.current) {
                _context.next = 8;
                break;
              }

              t(!0);
              _context.prev = 2;
              _context.next = 5;
              return o();

            case 5:
              _context.prev = 5;
              n.current || t(!1);
              return _context.finish(5);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2,, 5, 8]]);
    }));

    return function (_x) {
      return _ref6.apply(this, arguments);
    };
  }()];
};

var G = function G(_ref7, _ref8) {
  var e = _ref7.option,
      t = _ref7.shift,
      n = _ref7.cmd,
      r = _ref7.ctrl,
      o = _ref7.key;
  var s = _ref8.altKey,
      u = _ref8.shiftKey,
      i = _ref8.metaKey,
      a = _ref8.ctrlKey,
      p = _ref8.key;
  return s !== e || u !== t || i !== n || a !== r ? !1 : typeof o == "undefined" || typeof o == "string" && o === p;
},
    J = function J(e) {
  var _c2 = c(e),
      t = _c2.add,
      n = _c2.remove,
      r = _c2._ref;

  return {
    bind: function bind(s, u, i) {
      var _i$target;

      var a = s.key,
          _s$option = s.option,
          p = _s$option === void 0 ? !1 : _s$option,
          _s$shift = s.shift,
          m = _s$shift === void 0 ? !1 : _s$shift,
          _s$cmd = s.cmd,
          x = _s$cmd === void 0 ? !1 : _s$cmd,
          _s$ctrl = s.ctrl,
          R = _s$ctrl === void 0 ? !1 : _s$ctrl,
          M = (_i$target = i === null || i === void 0 ? void 0 : i.target) !== null && _i$target !== void 0 ? _i$target : function () {
        return window;
      };
      t(M, "keydown", function (l) {
        !G({
          option: p,
          shift: m,
          cmd: x,
          ctrl: R,
          key: a
        }, l) || u(l);
      }, i);
    },
    unbind: n,
    _ref: r
  };
};

import { useEffect as Q, useRef as Z } from "react";

var ee = function ee() {
  var e = Z([]);
  return Q(function () {
    return function () {
      e.current.forEach(function (r) {
        return r();
      }), e.current = [];
    };
  }, []), {
    use: function use(r) {
      e.current.push(r);
    },
    disuse: function disuse() {
      e.current = [];
    },
    _ref: e
  };
};

import { useEffect as te, useRef as ne } from "react";

var re = function re() {
  var e = ne(!0);
  return e.current ? (e.current = !1, !0) : e.current;
},
    oe = function oe(e, t) {
  var n = re();
  te(function () {
    if (!n) return e();
  }, t);
};

var se = function se() {
  var _f2 = f(),
      e = _f2.use,
      t = _f2._ref;

  return {
    use: function () {
      var _use = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(r) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", new Promise(function (o) {
                  return e(o, r);
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function use(_x2) {
        return _use.apply(this, arguments);
      }

      return use;
    }(),
    _ref: t
  };
};

import { useState as ue } from "react";

var ie = function ie() {
  var _ue = ue({
    x: void 0,
    y: void 0
  }),
      _ue2 = _slicedToArray(_ue, 2),
      e = _ue2[0],
      t = _ue2[1],
      _c3 = c(),
      n = _c3.add,
      r = _c3.remove,
      o = function o() {
    return t({
      x: window.scrollX,
      y: window.scrollY
    });
  };

  return [e, {
    use: function use(i) {
      r(), o(), n(window, "scroll", o, i);
    },
    disuse: function disuse() {
      r(), t({
        x: void 0,
        y: void 0
      });
    }
  }];
};

export { g as useAsyncEffect, O as useAsyncMemo, U as useBoolean, P as useDebounce, c as useEventListener, N as useHashState, y as useIsUnmounted, z as useNumber, Y as useSequenceState, J as useShortcut, f as useTimeout, ee as useUnmount, oe as useUpdateEffect, se as useWait, ie as useWindowScrollState };